export default function StepsSection({ steps = [] }) {
    return (
        <section className="steps-section">
            <h2>Steps to Find Your Perfect Carpet</h2>

            <div className="steps-grid">
                {steps.map((item) => (
                    <div className="step-item" key={item.key}>
                        <div className="track_sub_ot">
                            <div className="img_buster">
                                <img
                                    src={item?.media}
                                    alt={item?.name}
                                    className="img_icon_fcar"
                                />

                            </div>
                            <div>
                                <h3>{item?.name}</h3>
                                <p dangerouslySetInnerHTML={{ __html: item?.description }}></p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
